// use a separate module to allow jest to mock the module in test files
export const pingInterval = 3_000;
export const defaultTimeout = 20_000;
export const missedPongTimeout = 10_000;
export const uploadTimeout = 180_000;
export const bluetoothConnectTimeout = 60_000;
